<template>
  <div class="pa-3">
    <div v-for="(productType, i) in productTypes" :key="i">
      <h5>{{ productType.name }}</h5>
      <v-checkbox
        :label="$t('product_types.show_this_product_type_only')"
        class="mt-0 mb-2"
        hide-details
        dense
        :input-value="selectedProductTypeIds[productType.id] === true"
        @change="onCheckboxChange(productType, $event)"
        :true-value="true"
        :false-value="false"
      />
      <template v-if="showProductAttributeFilters">
        <v-text-field
          v-for="(attribute, j) in productType.attributes"
          :key="j"
          :label="attribute.key"
          :hint="attribute.description"
          persistent-hint
          outlined
          dense
          clearable
          @input="onFilterChange(attribute, $event)"
        />
      </template>
      <v-divider v-if="i < productTypes.length - 1" class="mb-2" />
    </div>
  </div>
</template>

<script>
import { API } from "@/api/api";
import { EventBus } from "@/eventBus";
import SnackbarMixin from "@/mixins/SnackbarMixin";

export default {
  name: "ProductTypeFilter",
  mixins: [SnackbarMixin],
  data: () => ({
    // loading
    isBusyProductTypes: false,
    // data
    productTypes: [],
    selectedProductTypeIds: {}
  }),
  computed: {
    showProductAttributeFilters() {
      return Number(process.env.VUE_APP_SHOW_PRODUCT_ATTRIBUTE_FILTERS) === 1;
    },
    inactiveProductTypeIdsRaw() {
      return process.env.VUE_APP_INACTIVE_PRODUCT_TYPE_EXTERNAL_IDS;
    },
    hasInactiveProductTypeIdsConfig() {
      if (
        this.inactiveProductTypeIdsRaw === null ||
        this.inactiveProductTypeIdsRaw === undefined
      ) {
        return false;
      }

      const value = ("" + this.inactiveProductTypeIdsRaw).trim().toLowerCase();
      return !["", "null", "undefined"].includes(value);
    },
    inactiveProductTypeIds() {
      if (!this.hasInactiveProductTypeIdsConfig) {
        return [];
      }

      return ("" + this.inactiveProductTypeIdsRaw)
        .split(",")
        .map(id => id.trim())
        .filter(id => id !== "");
    },
    warehouseId() {
      let userId = this.$store.getters["identity/getUserId"];
      if (userId === null) {
        this.snackbarError(this.$t("snackbar.identity_check_failed"));
        return;
      }

      return this.$store.getters["warehouse/getWarehouseId"](userId);
    }
  },
  methods: {
    onCheckboxChange(productType, value) {
      this.$set(this.selectedProductTypeIds, productType.id, value);
      EventBus.$emit("product-type", productType, value);
    },
    onFilterChange(productTypeAttribute, value) {
      if ([null, ""].includes(value)) {
        EventBus.$emit("product-type-attribute", productTypeAttribute, null);
      } else {
        EventBus.$emit("product-type-attribute", productTypeAttribute, value);
      }
    },
    initializeProductTypeSelection() {
      const selectedProductTypeIds = {};
      const hasInactiveProductTypeIdsConfig = this
        .hasInactiveProductTypeIdsConfig;
      const inactiveProductTypeIds = this.inactiveProductTypeIds;

      this.productTypes.forEach(productType => {
        const productTypeId = "" + productType.external_id;
        const isInactive = inactiveProductTypeIds.includes(productTypeId);

        // console.log("[DEBUG] productTypeId", productTypeId); // eslint-disable-line no-console
        // console.log("[DEBUG] inactiveProductTypeIds", inactiveProductTypeIds); // eslint-disable-line no-console
        // console.log("[DEBUG] isInactive", isInactive); // eslint-disable-line no-console

        selectedProductTypeIds[productType.id] = hasInactiveProductTypeIdsConfig
          ? !isInactive
          : false;
      });

      this.selectedProductTypeIds = selectedProductTypeIds;
      EventBus.$emit("product-types-initialized", {
        ...selectedProductTypeIds
      });
    },
    fetchProductTypes() {
      this.isBusyProductTypes = true;
      API.get("/api/product-types")
        .then(response => {
          this.productTypes = response.data.filter(productType =>
            productType.warehouse_ids.includes(this.warehouseId)
          );
          this.productTypes.sort((a, b) => a.name.localeCompare(b.name));
          this.initializeProductTypeSelection();
        })
        .catch(error => {
          this.snackbarError(error);
          EventBus.$emit("product-types-initialized", {});
        })
        .finally(() => {
          this.isBusyProductTypes = false;
        });
    }
  },
  created() {
    this.fetchProductTypes();
  }
};
</script>
